var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main", { staticClass: "portal-branding-harness" }, [
    _c(
      "section",
      [
        _vm.logo
          ? _c("img", { attrs: { src: _vm.logo, alt: "Brand Kit logo" } })
          : _vm._e(),
        _c("h1", [_vm._v("Client portal Brand Kit")]),
        _c("p", [
          _vm._v(
            "Representative production controls for development-only visual regression checks."
          )
        ]),
        _c(
          "div",
          { staticClass: "harness-actions" },
          [
            _c("v-btn", { staticClass: "super-action" }, [
              _vm._v("Primary action")
            ]),
            _c("v-btn", { staticClass: "primary-action" }, [
              _vm._v("Secondary action")
            ]),
            _c("v-btn", { staticClass: "secondary-action" }, [
              _vm._v("Alternate secondary action")
            ]),
            _c(
              "v-btn",
              { staticClass: "super-action", attrs: { disabled: "" } },
              [_vm._v("Disabled action")]
            ),
            _c(
              "button",
              { staticClass: "new-request-action", attrs: { type: "button" } },
              [_vm._v("+ New Request")]
            )
          ],
          1
        ),
        _vm._m(0),
        _c("v-text-field", {
          attrs: { outlined: "", label: "Name" },
          model: {
            value: _vm.name,
            callback: function($$v) {
              _vm.name = $$v
            },
            expression: "name"
          }
        }),
        _c("v-select", {
          attrs: { items: _vm.statuses, outlined: "", label: "Status" },
          model: {
            value: _vm.status,
            callback: function($$v) {
              _vm.status = $$v
            },
            expression: "status"
          }
        }),
        _c("v-textarea", {
          attrs: { outlined: "", label: "Notes" },
          model: {
            value: _vm.notes,
            callback: function($$v) {
              _vm.notes = $$v
            },
            expression: "notes"
          }
        }),
        _c("v-text-field", {
          attrs: {
            outlined: "",
            label: "Required field",
            "error-messages": "This field is required"
          }
        }),
        _c("v-checkbox", {
          attrs: { label: "Send me updates" },
          model: {
            value: _vm.subscribed,
            callback: function($$v) {
              _vm.subscribed = $$v
            },
            expression: "subscribed"
          }
        }),
        _c(
          "v-radio-group",
          {
            attrs: { row: "" },
            model: {
              value: _vm.frequency,
              callback: function($$v) {
                _vm.frequency = $$v
              },
              expression: "frequency"
            }
          },
          [
            _c("v-radio", { attrs: { label: "Weekly", value: "weekly" } }),
            _c("v-radio", { attrs: { label: "Monthly", value: "monthly" } })
          ],
          1
        ),
        _c("v-data-table", {
          staticClass: "portal-compact-table",
          attrs: {
            headers: _vm.tableHeaders,
            items: _vm.tableItems,
            "disable-pagination": "",
            "hide-default-footer": ""
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "nav",
      {
        staticClass: "tabs-component harness-tabs",
        attrs: { "aria-label": "Representative context navigation" }
      },
      [
        _c(
          "button",
          { staticClass: "tab-item selected", attrs: { type: "button" } },
          [_vm._v("Requests")]
        ),
        _c("button", { staticClass: "tab-item", attrs: { type: "button" } }, [
          _vm._v("Forms")
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }